import module from '../module';

function InputCompareToLink($scope, element, attributes, $ngModel) {

    $ngModel.$validators.compareTo = function (modelValue) {
        return modelValue === $scope.compareTo;
    };

    $scope.$watch('compareTo', function () {
        $ngModel.$validate();
    });
}

module.directive('compareTo', function () {
    return {
        require: 'ngModel',
        scope: {
            compareTo: '=compareTo'
        },
        link: InputCompareToLink
    };
});



// WEBPACK FOOTER //
// ./src/modules/shared/directives/InputCompareToDirective.js